import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPrevious = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 8,
	height: 12,
	viewBox: "0 0 8 12",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21.2213207,17.0021331 L18,14.0039421 L24.4507644,8 L25.2253822,8.72096268 C25.6514749,9.11754135 26,9.44942563 26,9.45832996 C26,9.46723645 24.9050552,10.4938363 23.566861,11.7393744 L21.1337221,14.0039781 L23.566861,16.2685819 C24.905081,17.514108 26,18.540746 26,18.5496263 C26,18.5655641 24.4673455,20 24.4501971,20 C24.4456643,20 22.9920673,18.6509101 21.2202377,17.0018091 L21.2213207,17.0021331 Z",
		transform: "translate(-18 -8)"
	})
});
export default SvgPrevious;
